module.exports = __webpack_public_path__ + "d37e9d85d9a5ff0015b8c22a6a130b6c.pdf";